import { useTranslation } from 'react-i18next';
import { Info, Mail, Calendar } from 'lucide-react';
import { APP_VERSION } from '../data/const_vars';

const Footer = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();
  const currentDate = new Date().toDateString();

  // Access the LICENSED_TO variable from Vite's environment
  const licensedTo = import.meta.env.VITE_LICENSED_TO;

  return (
    <footer className="relative z-10 bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 py-6 mt-8">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row md:justify-between items-center">
          <div className="flex items-center mb-4 md:mb-0">
            <Info size={16} className="text-gray-500 dark:text-gray-400 mr-2" />
            <span className="text-sm text-gray-500 dark:text-gray-400">
              {t('version')}: <span className="font-medium">{APP_VERSION}</span>
            </span>
            <Calendar size={16} className="m-2 text-gray-500 dark:text-gray-400" />
            <span className="text-sm text-gray-500 dark:text-gray-400"> {t('currentDate')}: <span className="font-medium">{currentDate}</span>
            </span>
          
          </div>

          
          <div className="flex flex-col md:flex-row items-center space-y-2 md:space-y-0 md:space-x-6">
             {/* <a 
              href="mailto:support@tcnw.com" 
              className="flex items-center text-sm text-blue-600 dark:text-blue-400 hover:underline"
            >
              <Mail size={16} className="mr-1" />
              <span>{t('suggestAFeatureBtnText')}</span>
            </a> */}

            <a 
              href={`mailto:support@tcnw.com?subject=${encodeURIComponent('PrimeDocs Feature Request')}&body=${encodeURIComponent(`Feature Request Details:
Title: 
[Please provide a short, descriptive title for your feature request]

Description:
[Please describe the feature you'd like to see]

Use Case:
[Explain how this feature would help you]

Additional Context:
[Any other information that might be helpful]

---
App Version: ${APP_VERSION}`)}`}
              target="_blank"
            rel="noopener noreferrer"
              className="flex items-center text-sm text-blue-600 dark:text-blue-400 hover:underline"
            >
              <Mail size={16} className="mr-1" />
              <span>{t('suggestAFeatureBtnText')}</span>
            </a>

            <a target="_blank" rel="noopener noreferrer" href={`mailto:support@tcnw.com?subject=${encodeURIComponent('PrimeDocs Support Request')}&body=${encodeURIComponent(`Support Request Details:

Please describe the issue you are facing, including any error messages or steps to reproduce the issue:
Issue: 

Additional Context:
[Any other information that might be helpful]

---
App Version: ${APP_VERSION}`)}`}
                
                className="flex items-center text-sm text-blue-600 dark:text-blue-400 hover:underline"
            >
              <Mail size={16} className="mr-1" />
              <span>{t('requestSupport')}</span>
            </a>
            
            <span className="text-sm text-gray-500 dark:text-gray-400">
              © {currentYear} PrimeDocs. {t('allRightsReserved')}
            </span>
          </div>

        </div>
        <div className="flex items-center pt-4 pb-4 md:mt-0">
            <span className="text-sm text-gray-500 dark:text-gray-400">
              Licensed To: {licensedTo}
            </span>
            </div>
      </div>
    </footer>
  );
};

export default Footer;
